import types from "./types";

export const singleImageUploadStart = (payload) => ({
  type: types.SINGLE_IMAGE_UPLOAD_START,
  payload,
});
export const singleImageUploadStateReset = () => ({
  type: types.SINGLE_IMAGE_UPLOAD_STATE_RESET,
});
